// removed by extract-text-webpack-plugin
module.exports = {"home":"home__2tZj_","content":"content__IR-PZ","options":"options__zTiz9","option-base":"option-base__Y8yeD","name":"name__3x1zN","details":"details__1veCd","emoji":"emoji__2Yw0o","button-container":"button-container__1r2mY","api-table":"api-table__F5GbZ","titles":"titles__23TVA","api":"api__2Ath0","key":"key__1yTgn","button-copy":"button-copy__eRJ8o"};


//////////////////
// WEBPACK FOOTER
// ./routes/teams/teamAPIKeys/style.css
// module id = LBbB
// module chunks = 14